import { MetamaskService } from '@/src/services/MetamaskService'
import { useCallback, useEffect } from 'react'
import { atom, useRecoilState } from 'recoil'

const walletAddressAtom = atom({ key: 'MetamaskWalletAddress', default: '' })

export const useMetamaskWalletAddress = () => {
  const [walletAddress, setWalletAddress] = useRecoilState(walletAddressAtom)
  const updateWalletAddress = useCallback(() => {
    MetamaskService.getWalletAddress().then((address) => {
      setWalletAddress(address ?? '')
    })
  }, [setWalletAddress])

  useEffect(() => {
    if (!MetamaskService.isInstalledMetamask()) return
    updateWalletAddress()
    window.ethereum.on('accountsChanged', updateWalletAddress)
    return () => {
      window.ethereum.removeListener('accountsChanged', updateWalletAddress)
    }
  }, [updateWalletAddress])

  return { walletAddress }
}
